<template>
    <div class="house-status" v-if="value" :class="[className, theme]">
        <span class="status-text">{{ value }}</span>
    </div>
</template>
<script>
export default {
    props: {
        className: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        theme: {
            type: String,
            default: ''
        }
    }
};
</script>
<style lang="scss">
.house-status {
    display: inline-block;
    padding: 3px 5px;
    font-size: 0;
    .status-text {
        display: inline-block;
        font-size: 12px;
        line-height: 14px;
    }
    &.v1,
    &.v2 {
        background: #348cff;
        border-radius: 2px;
        color: #fff;
        font-family: var(--font-bold);
        &.hot {
            background: #f05252;
        }
        &.open-house {
            background: #45adff;
        }
        &.new {
            background: #23c864;
        }
        &.price-reduced {
            background: #ff973b;
        }
        &.active {
            background: #bb40ef;
        }
        &.sold {
            background: #a8a8a8;
        }
        &.exclusive {
            background: #2cd781;
        }
    }
    &.v3 {
        background: rgba(81, 86, 102, 0.1);
        border-radius: 2px;
        color: #515666;
        font-family: var(--font-normal);
        &.hot {
            background: rgba(240, 82, 82, 0.1);
            color: #f05252;
        }
        &.open-house {
            background: rgba(69, 173, 255, 0.1);
            color: #45adff;
        }
        &.new {
            background: rgba(98, 178, 128, 0.1);
            color: #62b280;
        }
        &.price-reduced {
            background: rgba(239, 120, 79, 0.1);
            color: #ef784f;
        }
        &.active {
            background: rgba(187, 64, 239, 0.1);
            color: #bb40ef;
        }
        &.exclusive {
            background: #2cd781;
            color: #fff;
        }
    }
    &.v4 {
        color: #ffffff;
        font-family: var(--font-normal);
        background: rgba(129, 149, 189, 0.5);
        &.hot {
            background: rgba(240, 82, 82, 0.5);
        }
        &.open-house {
            background: rgba(76, 132, 255, 0.5);
        }
        &.new {
            background: rgba(87, 175, 120, 0.5);
        }
        &.price-reduced {
            background: rgba(255, 115, 48, 0.5);
        }
        &.active {
            background: rgba(187, 64, 239, 0.5);
        }
        &.exclusive {
            background: #2cd781;
            border-radius: 2px;
        }
    }
    &.v5 {
        background: #348cff;
        border-radius: 2px;
        color: #ffffff;
        font-family: var(--font-bold);
        &.hot {
            background: #fb6f67;
        }
        &.open-house {
            background: #45adff;
        }
        &.new {
            background: #23c864;
        }
        &.price-reduced {
            background: #ff973b;
        }
        &.active {
            background: #ff781d;
        }
        &.sold {
            background: #a8a8a8;
        }
        &.exclusive {
            background: #2cd781;
        }
    }
    &.v8 {
        background: rgba(129, 149, 189, 0.5);
        border-radius: 2px;
        color: #ffffff;
        text-align: center;
        margin-right: 10px;
        &.hot {
            background: rgba(240, 82, 82, 0.5);
        }
        &.open-house {
            background: rgba(76, 132, 255, 0.5);
        }
        &.new {
            background: rgba(87, 175, 120, 0.5);
        }
        &.price-reduced {
            background: rgba(255, 115, 48, 0.5);
        }
        &.active {
            background: rgba(187, 64, 239, 0.5);
        }
        &.sold {
            background: rgba(129, 149, 189, 0.5);
        }
        &.exclusive {
            background: #2cd781;
        }
    }
}
</style>
